import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Text } from '../../styles/GenericStyled';
import bookIcon from '../../styles/images/privateSpaces/icons/book-b.png';
import boothIcon from '../../styles/images/privateSpaces/icons/booth-b.png';
import circleBalckIcon from '../../styles/images/privateSpaces/icons/circle-black.png';
import groupBlackIcon from '../../styles/images/privateSpaces/icons/group-black.png';
import handsIcon from '../../styles/images/privateSpaces/icons/hands-b.png';
import museumcon from '../../styles/images/privateSpaces/icons/museum-b.png';

const icons = [
  {
    path: bookIcon,
    text: 'Educational Institutions',
  },
  {
    path: handsIcon,
    text: 'Non-profit Entities',
  },
  {
    path: museumcon,
    text: 'Art & Cultural Organizations',
  },
  {
    path: groupBlackIcon,
    text: 'Marketing & Communication Agencies',
  },
  {
    path: boothIcon,
    text: 'Brands',
  },
  {
    path: circleBalckIcon,
    text: 'Individuals, Freelancers & Artists',
  },
];

const IconsSection = () => {
  return (
    <Grid
      container
      justify="space-evenly"
      style={{ minHeight: '169px', marginTop: '23px' }}
      spacing={4}
    >
      {icons.map((icon, index) => (
        <Grid
          container
          item
          style={{ textAlign: 'center' }}
          direction="column"
          justify="flex-end"
          lg={2}
          md={4}
          xs={6}
          key={index}
        >
          <Grid item style={{ marginBottom: 'auto' }}>
            <Text style={{ maxWidth: '256px', margin: 'auto' }} type="body1" align="center">
              {icon.text}
            </Text>
          </Grid>
          <Grid item>
            <img src={icon.path} width={'70px'} height={'70px'} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default IconsSection;
